import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import { deleteBrand } from '../brands/saga';
import actions from './actions';

export function* getCategories() {
    yield takeEvery(actions.FETCH_CATEGORIES_REQUESTED, function* (action) {
        try {
            const categories = yield call(actions.getCategories, action.payload);
            yield put({ type: actions.FETCH_CATEGORIES_SUCCEEDED, categories });
        } catch (error) {
            yield put({ type: actions.FETCH_CATEGORIES_FAILED, error: error.message });
        }
    });
}

export function* getCategory() {
      yield takeEvery(actions.FETCH_CATEGORY_REQUESTED, function* (action) {
            try {
                const category = yield call(actions.getCategory, action.payload);
                yield put({ type: actions.FETCH_CATEGORY_SUCCEEDED, category: category.category_info });
            } catch (error) {
                yield put({ type: actions.FETCH_CATEGORY_FAILED, error: error.message });
            }
      });
}

export function* deleteCategory() {
    yield takeEvery(actions.DELETE_CATEGORY_REQUESTED, function* (action) {
        try {
            const category = yield call(actions.deleteCategory, action.payload);
            yield put({ type: actions.DELETE_CATEGORY_SUCCEEDED, categoryDeleted: category });
        } catch (error) {
            yield put({ type: actions.DELETE_CATEGORY_FAILED, error: error.response.data });
        }
    });
  }

export default function* rootSaga() {
  yield all([
    fork(getCategories),
    fork(getCategory),
    fork(deleteCategory)
  ]);
}
